import XAxisDateTick from './XAxisDateTick'

export {XAxisDateTick}
